import * as React from "react";
import { Marker, Tooltip, Popup } from "react-leaflet";
import L from "leaflet";
import CartPopUp from './cartPopUp';
import { renderToStaticMarkup } from "react-dom/server";
import { ReactComponent as CartAvailableIcon } from "../../assets/icons/cartIcons/cart_avalible.svg";
import { ReactComponent as CartBusyIcon } from "../../assets/icons/cartIcons/cart_busy.svg";
import { ReactComponent as CartAvailableHoverIcon } from "../../assets/icons/cartIcons/cart_avalible_hover.svg";
import { ReactComponent as CartShuttleIcon } from "../../assets/icons/cartIcons/cart_shuttle_icon.svg";
import { ReactComponent as CartShuttleHoverIcon } from "../../assets/icons/cartIcons/cart_shuttle_icon_hover.svg";
import { ReactComponent as CartBusyHoverIcon } from "../../assets/icons/cartIcons/cart_busy_hover.svg";
import { ReactComponent as CartError } from "../../assets/icons/cartIcons/cart_error.svg";
import { ReactComponent as CartErrorMid } from "../../assets/icons/cartIcons/cart_error_mid.svg";
import { ReactComponent as CartCharging } from "../../assets/icons/cartIcons/cart_charging.svg";
import { ReactComponent as CartOffline } from "../../assets/icons/cartIcons/cart_offline.svg";
import common_types from "../../common_files/common_types";
import useAuth from "../../hooks/Auth/useAuth";

import "animate.css";

const cartIconAvailableHover = renderToStaticMarkup(<CartAvailableHoverIcon />);
const cartIconAvailable = renderToStaticMarkup(<CartAvailableIcon />);
const cartIconBusy = renderToStaticMarkup(<CartBusyIcon />);
const cartIconBusyHover = renderToStaticMarkup(<CartBusyHoverIcon />);
const cartIconShuttle = renderToStaticMarkup(<CartShuttleIcon />);
const cartIconShuttleHover = renderToStaticMarkup(<CartShuttleHoverIcon />);
const errorCircle = '<div class="anim-circle-error"></div>';
const pathCircle = '<div class="anim-circle-path"></div>';

const cartOnlineIcon = (cartInfo, onHoverCart, cartToShowPath) => L.divIcon({
  className: "",
  iconAnchor: [5, 5],
  html: `
  <div class="center_cart">  
    <div class="center_cart" style="transform:rotate(${cartInfo.yaw}deg);z-index:20;position:absolute;">
    ${  
      cartInfo.available && cartInfo.online
        ? onHoverCart === cartInfo.cart_number
          ? cartIconAvailableHover
          : cartIconAvailable
        : onHoverCart === cartInfo.cart_number
          ? cartInfo.mission_type === common_types.mission_type_enum.MISSION_TYPE_SHUTTLE
            ? cartIconShuttleHover
            : cartIconBusyHover
          : cartInfo.mission_type === common_types.mission_type_enum.MISSION_TYPE_SHUTTLE
            ? cartIconShuttle
            : cartIconBusy
    }
  </div>
  ${(Array.isArray(cartInfo.errors) && cartInfo.errors.length > 0) || cartInfo.path_status === 'BLOCKED_STABLE' ? errorCircle : cartToShowPath.includes(cartInfo.cart_number) ? pathCircle : '' }
  </div>`
});

const cartOfflineIcon = (cartInfo, onHoverCart) => L.divIcon({
  className: "",
  iconAnchor: [5, 45],
  html: `
  <div > 
  <div ">${onHoverCart === cartInfo.cart_id ? cartIconBusyHover : cartIconBusy}</div>
  </div>`
});

function MarkerOnline({ position, id, cartInfo, cartToShowPath, setCartToShowPath, cartsPaths, setOnHoverCart, onHoverCart,selectedCart, setSelectedCart,setStaticPopup }) {
  let {getConfigValue, isPhoneSize} = useAuth();
  const showWarningAlerts = getConfigValue('show_warning_events') ?? false;

  const eventHandlers = {
    click: (e) => {
      try {
        const map = e.target._map; // Access the map instance
        if (!map) { return; }
        const markerLatLng = e.latlng; 
        if (!markerLatLng || typeof markerLatLng.lat !== 'number' || typeof markerLatLng.lng !== 'number') { return; }

        // Check if popup is already open for this cart (toggle behavior)
        if (setStaticPopup) {
          setStaticPopup((currentPopup) => {
            if (currentPopup && currentPopup.cartInfo && currentPopup.cartInfo.cart_number === cartInfo.cart_number) {
              // If popup is already open for this cart, close it
              return { position: null, cartInfo: null };
            } else {
              // If popup is not open or open for different cart, open it for this cart
              const markerScreenPoint = map.latLngToContainerPoint(markerLatLng); // Convert to screen point
              const popupOffset = markerScreenPoint.y > 400 ? [0, -50] : [0, 350];

              return {
                position: markerLatLng,
                cartInfo: { ...cartInfo, offline: false },
                popupOffset,
                uiMode: isPhoneSize ? 'slider' : 'popup'
              };
            }
          });
        }
      } catch (error) {
        console.error('Error handling marker click:', error);
      }
    },
  };
  

  const showToolTip = showWarningAlerts 
    ? ( (Array.isArray(cartInfo.errors) && cartInfo.errors.length > 0) 
    || (cartInfo.path_status === 'BLOCKED_STABLE') 
    || (Array.isArray(cartInfo.warnings) && cartInfo.warnings.length > 0) 
    || (cartInfo.mission_type === "MISSION_TYPE_CHARGING" )) 
    : (Array.isArray(cartInfo.errors) && cartInfo.errors.length > 0) 
    || (cartInfo.path_status === 'BLOCKED_STABLE')

  return (
    <Marker
      position={position}
      eventHandlers={eventHandlers}
      icon={cartOnlineIcon(cartInfo, onHoverCart, cartToShowPath)}
    >
      {showWarningAlerts && (
        <Tooltip permanent>
          <div>
            {Array.isArray(cartInfo.errors) && cartInfo.errors.length > 0 ? (
              <CartError />
            ) : Array.isArray(cartInfo.warnings) &&
              cartInfo.warnings.length > 0 ? (
              <CartErrorMid />
            ) : cartInfo.mission_type === "MISSION_TYPE_CHARGING" ? (
              <CartCharging />
            ) : null}
          </div>
        </Tooltip>
      )}
    </Marker>
  );
}
export const MarkerOnlineContainer = React.memo(MarkerOnline);

function MarkerOffline({ position, id, cartInfo, setOnHoverCart, onHoverCart }) {

  const eventHandlers = {
    click: (e) => {
      setOnHoverCart(cartInfo.cart_number);
      e.target.openPopup();
    },
  };

  return (
    <Marker
      position={position}
      eventHandlers={eventHandlers}
      icon={cartOfflineIcon(cartInfo, onHoverCart)}
    >
      <Tooltip permanent>
        <div>
          <CartOffline />
        </div>
      </Tooltip>
      <Popup key={`popup-close-${cartInfo.cart_id}`} offset={[0, -50]} autoClose={true}>
        <CartPopUp
          key={`CartPopUp-close-${cartInfo.cart_id}`}
          cartInfo={cartInfo}
          offline={true}
          
        />
      </Popup>
    </Marker>
  );
}

export const MarkerOfflineContainer = React.memo(MarkerOffline);
